(() => {
    const updatePrices = () => {
      const salePrices = Array.from(document.querySelectorAll(".price--on-sale"));
      salePrices.forEach((salePrice) => {
        const discounted = salePrice.querySelector(".price__current");
        const full = salePrice.querySelector(".price__was");
        if (!discounted || !full) return;
  
        const discountedPrice = parseFloat(discounted.innerText.replace("$", ""));
        const fullPrice = parseFloat(full.innerText.replace("$", ""));
        if (discountedPrice >= fullPrice) return;
  
        const discountNumber = fullPrice - discountedPrice;
        const discountPercent = Math.round(
          parseFloat((discountNumber * 100) / fullPrice)
        );
  
        const cardBadge = salePrice
          .closest(".card--product")
          ?.querySelector(".product-label--sale");
        const productPrice = salePrice
          .closest(".product-info")
          ?.querySelector(".price__current");
        if (cardBadge) {
          if (cardBadge.innerText.indexOf("%") === -1) {
            cardBadge.innerText = `${discountPercent}% OFF`;
          }
        } else if (productPrice) {
          if (productPrice.innerText.indexOf("%") === -1) {
            productPrice.insertAdjacentText(
              "beforeend",
              `(${discountPercent}% OFF)`
            );
          }
        }
      });
    };
    updatePrices();
    document.addEventListener("on:variant:change", () => {
      updatePrices();
    });
    const productGrid = document.querySelector(".main-products-grid__results");
    if (productGrid) {
      const observer = new MutationObserver((mutations) => {
        window.setTimeout(() => {
          updatePrices();
        }, 100);
      });
      observer.observe(productGrid, {
        attributes: true,
      });
    }
    const recentlyViewed = document.querySelector("recently-viewed");
    if (recentlyViewed) {
      const observer = new MutationObserver((mutations) => {
        window.setTimeout(() => {
          updatePrices();
        }, 100);
      });
      observer.observe(recentlyViewed, {
        childList: true,
      });
    }
    const productRecommendations = document.querySelector(
      "product-recommendations"
    );
    if (productRecommendations) {
      const observer = new MutationObserver((mutations) => {
        window.setTimeout(() => {
          updatePrices();
        }, 100);
      });
      observer.observe(productRecommendations, {
        childList: true,
      });
    }
  })();